import { render, staticRenderFns } from "./diffs_file_tree.vue?vue&type=template&id=61ba43a4"
import script from "./diffs_file_tree.vue?vue&type=script&lang=js"
export * from "./diffs_file_tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports